document.addEventListener('DOMContentLoaded', () => {
	const alertCloseLinks = document.querySelectorAll('.alert-close');
	alertCloseLinks.forEach(link => {
		link.addEventListener('click', e => {
			e.preventDefault();
			const closestAlertBar = e.target.closest('.wp-block-knightowl-blocks-alert-bar');
			if (closestAlertBar) {
				closestAlertBar.style.display = 'none';
			}
			document.cookie = 'hide-alert-bar=1; path=/';
		});
	});
});
